import React, { useState, useEffect, useRef, useEffectEvent } from "react";
import {
  Row,
  Button,
  Col,
  Checkbox,
  Card,
  Input,
  Space,
  Typography,
  message,
  Badge,
  Modal,
  Select,
  Divider,
  Table,
  Drawer,
  Tag,
  Spin,
  DatePicker,
  Popover,
  Tooltip,
  Radio,
} from "antd";
import Scrollbars from "react-custom-scrollbars";
import InfiniteScroll from "react-infinite-scroll-component";
import { v4 as uuidv4 } from "uuid";
import {
  CloseOutlined,
  LoadingOutlined,
  StopOutlined,
  SearchOutlined,
  PlusOutlined,
  MinusOutlined,
  ArrowRightOutlined,
  TransactionOutlined,
  TeamOutlined,
  PrinterOutlined,
  UndoOutlined,
  CalendarOutlined,
  RightOutlined,
} from "@ant-design/icons";
import Back from "../../../assets/images/backIcon.svg";
import CancelArrow from "../../../assets/images/cancelArrow.svg";
import Cash1 from "../../../assets/images/cash.svg";
import Card1 from "../../../assets/images/card.svg";
import Close from "../../../assets/images/close-x.svg";
// import Credit from "../../../assets/images/creditCardIcon.svg";
import Credit from "../../../assets/images/creditIcon.svg";
import Loyality from "../../../assets/images/loyalityIcon.svg";
import Gift from "../../../assets/images/giftIcon.svg";
import giftVoucher from "../../../assets/images/giftVoucher.svg";
import creditNote from "../../../assets/images/creditNote.svg";
import UPI from "../../../assets/images/upiIcon.svg";
import qrCodeIcon from "../../../assets/images/qrCodeIcon.svg";
import paymentSuccess from "../../../assets/images/payment-success.svg";
import defaultImage from "../../../assets/images/no-image.svg";
import DiscountIcon from "../../../assets/images/discountperIcon.svg";
import printBill from "../../../assets/images/printbillIcon.svg";
import Offers from "../../../assets/images/promoTag.svg";
import DeleteImg from "../../../assets/images/delete1.svg";
import userIcon from "../../../assets/images/userId.svg";
import clearFilters from "../../../assets/images/clearFilters.svg";
import CustomerSearch from "../../../assets/images/c-serach.svg";
import HCPrint from "../../../lib/printer/hardWareControllerPrinter";
import CWHCPrint from "../../../lib/printer/CWHardwareController";
import { xmlPrint } from "../../../lib/printer/xmlPrinter";
import { htmlPrint } from "../../../lib/printer/htmlPrinter";
import MenuLayout from "./MenuLayout";
import _ from "lodash";
import "./restaurantStyle.css";
import moment from "moment";
import db from "../../../database";
import { useTranslation } from "react-i18next";
import { getMultilingualText } from "../../../utility/getMultilingualText ";
import { useWindowDimensions } from "../../../lib/useViewport";
import PoleDisplay from "../../../lib/printer/poleDisplay";
import addNote from "../../../assets/images/addNote.svg";
import messages from "../../../errors/messages.en-IN.json";
import { getWorkflowData } from "../../../utility/getWorkflowData";
import { SyncData } from "./Tables-Management/SyncData";
import { useEventBus } from "../../../lib/hooks/EventBusProvider";

const OrderListComponent = ({
  setSelectedProductInCart,
  selectedProductId,
  setSelectedProductId,
  manualDiscountRestaurant,
  cart,
  selectedTable,
  setSelectedTable,
  tillDataPaymentMethods,
  setSelectedPaymentMethod,
  selectedPaymentMethod,
  setIsCardPaymentFlag,
  processOrder,
  amount,
  onChangeAmount,
  paymentModalInputRef,
  setIsInputFocused,
  requestPayment,
  handleCashPayment,
  handleAmount,
  setNumb,
  setKeyValue,
  paymentVisible,
  setPaymentVisible,
  showOrderCompleteFlag,
  setShowOrderCompleteFlag,
  userPreferences,
  showProducts,
  setShowProducts,
  filteredPaymentMethods,
  getFilteredPaymentMethods,
  tableCards,
  setAmount,
  setTableCards,
  setCart,
  denaminationsKeyboard,
  setDenaminationsKeyboard,
  saleType,
  setSaleType,
  occupiedDataTablesData,
  setOcupiedTablesData,
  reservedTablesData,
  setReservedTablesData,
  tableList,
  setTableList,
  showSplitBill,
  setShowSplitBill,
  splitBillScreen,
  setSplitBillScreen,
  numSplits,
  setNumSplits,
  setDisplayCustomerSearch,
  deleteProduct,
  handleOrder,
  showAllItems,
  setShowAllItems,
  splitCarts,
  setSplitCarts,
  isSplitBill,
  setIsSplitBill,
  currentSplitIndex,
  setCurrentSplitIndex,
  recordState,
  setRecardState,
  removeSplit,
  setRemoveSplit,
  setMainTableData,
  setSelectedSaleType,
  selectedSaleType,
  setSelectedSaleTypeData,
  searchOrderHistory,
  orderHistoryDetails,
  setOrderHistoryDetails,
  increaseProductQty,
  getSalesHistoryData,
  isPrintModeXML,
  upsertPOSLog,
  setFiltersFlag,
  dateRange,
  setDateRange,
  getDisplayDate,
  content,
  searchHistoryInput,
  setSearchhistoryInput,
  ordersCopy,
  isPopoverVisible,
  setPopoverVisible,
  dateRef,
  filtersFlag,
  setShowSendToKitchen,
  showSendToKitchen,
  sortedSaleTypes,
  setSelectedSaleTypeIndex,
  selectedReturnOrder,
  setSelectedReturnOrder,
  setCheckedKeys,
  checkedKeys,
  addSelectedReturnProductsToCart,
  getProductData,
  handleSaveReturnCartRecord,
  dataSource,
  setDataSource,
  productCategoriesList,
  setProductCategoriesList,
  selectedCategory,
  setSelectedCategory,
  restaurantProductCategory,
  bestsellerCategories,
  handleCategoryClick,
  saleTypeProducts,
  setSaleTypeProducts,
  handleSelectedSaleTypeForProducts,
  showReturnPurchase,
  setShowReturnPurchase,
  selectPurchaseBillForReturn,
  retrunSearchType,
  setReturnSearchType,
  searchReturnHistory,
}) => {
  const { Text, Title } = Typography;
  const { dispatchEvent } = useEventBus();
  const { width } = useWindowDimensions();
  const [orderTypeData, setOrderTypeData] = useState(0);
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const tillaccess = JSON.parse(tillData.tillAccess.userAccessController);
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const currenciesList = tillData?.tillAccess.csBunit.currencies;
  const [tableOrderData, setTableOrderData] = useState([]);
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const { t } = useTranslation();
  let searchCustomersRef = useRef();
  const paymentInProgressRef = useRef(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const themeJSON = posConfig?.themeJSON && posConfig?.themeJSON !== "N" && Object.keys(posConfig?.themeJSON).length > 0 ? JSON.parse(posConfig?.themeJSON)?.layout4 : {};
  const currenciesList1 = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
  const multilingual = process.env.REACT_APP_MULTILINGUAL === "true" && localStorage.getItem("selectedLanguage") !== "English";
  const [currenciesData, setCurrenciesData] = useState(tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => b.value - a.value) || []);
  const initialShowPayments = filteredPaymentMethods.length > 4 ? _.sortBy(filteredPaymentMethods, "sequenceNo").slice(0, 3) : _.sortBy(filteredPaymentMethods, "sequenceNo");
  const [showPayments, setShowPayments] = useState(initialShowPayments);
  const [isShowingAll, setIsShowingAll] = useState(false);
  const [OrderedItem, setOrderedItem] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(initialShowPayments.length);
  const { Option } = Select;
  const userData = JSON.parse(localStorage.getItem("userData"));
  const tillValue = JSON.parse(localStorage.getItem("tillValue"));
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [charges, showCharges] = useState(false);
  const scrollbarsRef = useRef(null);
  const debounceTimeoutRef = useRef(null);
  const pendingShowOrderComplete = useRef(false);
  const [maxScroll, setMaxScroll] = useState(0);
  const [currentScroll, setCurrentScroll] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [salesHistoryDrawer, setSalesHistoryDrawer] = useState(false);
  const [orderColors, setOrderColors] = useState({});
  const [orderStatusFilter, setOrderStatusFilter] = useState("All Status");
  const [returnDrawerOpen, setReturnDrawerOpen] = useState(false);
  const [returnItem, setReturnItem] = useState(null);
  const [returnQty, setReturnQty] = useState(1);
  const [returnType, setReturnType] = useState("wastage");
  const [reasonCode, setReasonCode] = useState(null);
  const [notes, setNotes] = useState("");
  const [reasonError, setReasonError] = useState(false);
  const [approvalVisible, setApprovalVisible] = useState(false);
  const ObFlag = tillData.tillAccess.cwrTill.printTemplate.obController === "Y" ? true : false;
  const CWHardwareController = tillData.tillAccess.cwrTill.printTemplate.cwController === "Y" ? true : false;
  const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData") || "{}");

  const getAllSaleTypes = async () => {
    const saleData = await db.posSaletypes.toArray();
    return saleData;
  };

  const returnReasons = ["Damaged Item", "Wrong Item Delivered", "Quality Issue", "Customer Changed Mind", "Expired Product", "Other"];

  const submitReturn = async () => {
    if (!returnItem) return;

    const data = [...dataSource]; // table data (same as original)

    // find row in dataSource
    const row = data.find((r) => r.sOrderlineID === returnItem.sOrderlineID);

    if (!row) return;

    // set qtyToReturn like table edit
    row.qtyToReturn = returnQty;

    // update state like original
    setDataSource(data);
    handleSaveReturnCartRecord(data);

    // select this row
    setCheckedKeys([row.key]);
    if (returnType === "wastage") {
      localStorage.setItem("wastageFlag", "Y");
    } else {
      localStorage.removeItem("wastageFlag");
    }
    // 🔥 call same function as main Return button
    await addSelectedReturnProductsToCart();

    setReturnDrawerOpen(false);
    setSalesHistoryDrawer(false);

    setKeyValue("2");
    // setTimeout(async () => {
    //   try {
    //     const orderSaleTypeId =
    //       selectedOrder?.saleType?.cwrSaletypeId;
    //     const allSaleTypes = await db.posSaletypes.toArray();
    //     const matchedSaleType = allSaleTypes.find(
    //       (s) => s.cwrSaletype?.cwrSaletypeId === orderSaleTypeId
    //     );
    //     if (matchedSaleType) {
    //       handleSelectedSaleTypeForProducts(matchedSaleType)();
    //     }
    //   } catch (e) {
    //     console.log("Error loading saletype after return:", e);
    //   }
    // }, 100);
    // 🔥 switch to Takeaway after return
    setTimeout(async () => {
      try {
        const allSaleTypes = await db.posSaletypes.toArray();

        // 🔥 get original sale type from order
        const orderSaleTypeId = selectedReturnOrder?.saleType?.cwrSaletypeId || selectedOrder?.saleType?.cwrSaletypeId;

        if (!orderSaleTypeId) return;

        // 🔥 find matching sale type in DB
        const matchedSaleType = allSaleTypes.find((s) => s.cwrSaletype?.cwrSaletypeId === orderSaleTypeId);

        if (!matchedSaleType) {
          console.log("No matching sale type found");
          return;
        }

        // 🔥 find tab index
        const index = sortedSaleTypes.findIndex((s) => s.cwrSaletype?.cwrSaletypeId === orderSaleTypeId);

        if (index !== -1) {
          setSelectedSaleTypeIndex(index);
        }

        // 🔥 apply sale type config
        handleSelectedSaleTypeForProducts(matchedSaleType)();

        // 🔥 set value
        setSaleType(matchedSaleType.cwrSaletype?.value);

        // 🔥 open billing screen
        setKeyValue("2");

        console.log("Navigated to:", matchedSaleType.cwrSaletype?.name);
      } catch (e) {
        console.log("Error switching to original sale type:", e);
      }
    }, 100);
  };

  const handleApproveAndProcess = async () => {
    setApprovalVisible(false);
    await submitReturn();
  };

  const handleProcessReturn = () => {
    // 🔴 inline reason validation
    if (!reasonCode) {
      setReasonError(true); // show red text under dropdown
      return;
    }

    // clear error if valid
    setReasonError(false);

    // 🟡 if stock → show approval popup
    if (returnType === "stock") {
      setApprovalVisible(true);
      return;
    }

    // 🟢 normal wastage return
    submitReturn();
  };

  const findMatchingColor = async (order) => {
    const saleTypes = await getAllSaleTypes();
    const saleTypeIdFromOrder = order?.saleType?.cwrSaletypeId;

    const matchingSaleType = saleTypes.find((saleType) => saleType?.cwrSaletype?.cwrSaletypeId === saleTypeIdFromOrder);

    return matchingSaleType?.cwrSaletype?.colourCode || "green";
  };

  useEffect(() => {
    const fetchColors = async () => {
      const colors = {};
      for (const order of orderHistoryDetails) {
        if (order?.sOrderID) {
          colors[order.sOrderID] = await findMatchingColor(order);
        }
      }
      setOrderColors(colors);
    };
    fetchColors();
  }, [orderHistoryDetails]);

  const modulo = (a, b) => {
    return a - b * Math.floor(a / b);
  };

  const showMoreItems = () => {
    const sortedData = _.sortBy(filteredPaymentMethods, "sequenceNo");
    const totalItems = sortedData.length;

    if (totalItems <= 4) return; // no more button needed

    let newStartIndex = endIndex; // next batch starts from current end
    let newEndIndex = newStartIndex + 3;

    // wrap around if reached end
    if (newStartIndex >= totalItems) {
      newStartIndex = 0;
      newEndIndex = 3;
    } else if (newEndIndex > totalItems) {
      newEndIndex = totalItems;
    }

    setShowPayments(sortedData.slice(newStartIndex, newEndIndex));
    setStartIndex(newStartIndex);
    setEndIndex(newEndIndex);
    // setIsShowingAll(true);
  };

  const showPreviousItems = () => {
    const sortedData = _.sortBy(filteredPaymentMethods, "sequenceNo").slice(0, 3);
    setShowPayments(sortedData);
    setStartIndex(0);
    setEndIndex(sortedData.length);
    setIsShowingAll(false);
  };

  const fetchMoreData = (event) => {
    const lengthOff = parseInt(localStorage.getItem("dataLength")) || 0;
    const newMaxScroll = event.target.scrollHeight - event.target.clientHeight;
    const newCurrentScroll = event.target.scrollTop;

    // Update scroll states
    setMaxScroll(newMaxScroll);
    setCurrentScroll(newCurrentScroll);

    // Ignore if scrolling horizontally
    if (scrollLeft !== event.target.scrollLeft) {
      setScrollLeft(event.target.scrollLeft);
      return;
    }

    // Check if scrolled to bottom and conditions for fetching are met
    if (
      Math.round(newCurrentScroll) >= Math.round(newMaxScroll) - 1 &&
      !filtersFlag && // Stop if filtersFlag is true (no more data)
      ordersCopy.length > 0 // Ensure there is initial data
    ) {
      let orderD = JSON.parse(localStorage.getItem("orderType")) || [];
      const newStartRow = lengthOff;
      const batchSize = 50; // Align with searchOrderHistory batch size

      if (orderD.length > 0) {
        // Prevent jitter by slightly adjusting scroll position
        if (scrollbarsRef.current) {
          scrollbarsRef.current.scrollTop(Math.round(newCurrentScroll) - 5);
        }

        // Determine if date filter is applied
        let dateFlag = true;
        if (dateRef.current?.textContent !== "Choose date range") {
          dateFlag = false;
        }

        // Debounce API call
        clearTimeout(debounceTimeoutRef.current);
        debounceTimeoutRef.current = setTimeout(() => {
          setLoading(true);
          searchOrderHistory(orderD[0], orderD[1], newStartRow, true, dateFlag)
            .then((response) => {
              const newData = response?.data?.data?.salesHistory || [];
              // Update dataLength in localStorage
              localStorage.setItem("dataLength", (newStartRow + newData.length).toString());
              if (newData.length === 0) {
                setFiltersFlag(true); // No more data
                // Message is already shown in searchOrderHistory
              }
            })
            .catch((error) => {
              console.error("Error fetching more data:", error);
              message.error(t("Failed to load more records"));
              setFiltersFlag(true); // Stop on error
            })
            .finally(() => {
              setLoading(false);
            });
        }, 300); // Debounce 300ms
      }
    }
  };

  // Add useEffect to attach/detach scroll event
  useEffect(() => {
    const scrollbars = scrollbarsRef.current?.view;
    if (scrollbars) {
      scrollbars.addEventListener("scroll", fetchMoreData);
      return () => {
        scrollbars.removeEventListener("scroll", fetchMoreData);
        clearTimeout(debounceTimeoutRef.current); // Cleanup debounce
      };
    }
  }, [salesHistoryDrawer, filtersFlag, ordersCopy]);

  const handleDeletePayment = (payment) => {
    let paid = 0;
    Promise.all(
      cart.payments.map(async (pay) => {
        if (pay.name !== payment.name && payment.name.toLowerCase() !== "card") {
          paid = paid + parseFloat(pay.amount);
          return pay;
        } else if (payment.name.toLowerCase() === "card" && (payment.authorization ? pay.authorization !== payment.authorization : true)) {
          paid = paid + parseFloat(pay.amount);
          return pay;
        }
      })
    )
      .then((results) => {
        // Filter out undefined results (where payment name matched)
        cart.payments = results.filter((result) => result !== undefined);
        cart.paid = paid + (cart?.advancePayment || 0);
        setAmount(parseFloat((cart.total - cart.paid).toFixed(2)));
        if (payment?.name?.toLowerCase() === "cash") {
          cart.tenderedAmount = cart.tenderedAmount - payment.amount;
        }
        localStorage.setItem("cartObj", JSON.stringify(cart));
        setCart(cart);
      })
      .catch((error) => {
        // Handle errors
        console.error(error);
      });
  };

  // useEffect(() => {
  //   if (orderTypeData === 0) {
  //     db.tableData.toArray().then((response) => {
  //       let finalData = response.filter((data) => data.statusType === "OCU");
  //       setTableOrderData(finalData);
  //     });
  //   } else if (orderTypeData === 1) {
  //     setTableOrderData([]);
  //   } else if (orderTypeData === 2) {
  //     db.orders
  //       .where("isSynced")
  //       .equals(1)
  //       .toArray()
  //       .then((response) => {
  //         setTableOrderData(response);
  //       });
  //   }
  // }, [orderTypeData]);

  useEffect(() => {
    db.orders
      .where("isSynced")
      .equals(1)
      .toArray()
      .then((response) => {
        setTableOrderData(response);
      });
  }, [orderTypeData]);

  const printReceipt = () => {};

  // useEffect(() => {
  //   db.orders
  //     .orderBy("orderTime")
  //     .reverse()
  //     .limit(1)
  //     .toArray()
  //     .then((response) => {
  //       console.log("response --------->", response);
  //       setOrderedItem(response);
  //     });
  // }, [cart, showOrderCompleteFlag]);

  // db.orders.toArray().then(
  //   (orders) => {
  //     const sorted = orders.sort((a, b) => new Date(b.orderTime) - new Date(a.orderTime));
  //     setOrderedItem([sorted[0]]);
  //   },
  //   [showOrderCompleteFlag]
  // );

  // useEffect(() => {
  //   db.orders.toArray().then((orders) => {
  //     console.log("Total orders:", orders.length);
  //     const parseDate = (str) => {
  //       const [datePart, timePart] = str.split(" ");
  //       const [day, month, year] = datePart.split("-");
  //       return new Date(`${year}-${month}-${day}T${timePart}`);
  //     };

  //     orders.forEach((o) => {
  //       console.log(o.orderTime, "→", new Date(o.orderTime), "→", parseDate(o.orderTime));
  //     });

  //     const sorted = orders.sort((a, b) => parseDate(b.orderTime) - parseDate(a.orderTime));
  //     console.log("sortedd ===============>", sorted);
  //     console.log("sorted[0] ==============>", sorted[0]);
  //     setOrderedItem([sorted[0]]);
  //   });
  // }, [showOrderCompleteFlag, cart, db.orders]);

  useEffect(() => {
    db.orders.toArray().then((orders) => {
      // Reliable parser that handles both your formats
      const parseOrderTime = (str) => {
        if (!str || typeof str !== "string") return new Date(0);

        const cleaned = str.trim();

        let year,
          month,
          day,
          hour = 0,
          minute = 0,
          second = 0;

        // Case 1: DD-MM-YYYY HH:mm:ss    e.g. 14-01-2026 14:23:22
        if (cleaned.match(/^\d{1,2}-\d{1,2}-\d{4}/)) {
          const [datePart, timePart = "00:00:00"] = cleaned.split(/\s+/);
          const [d, m, y] = datePart.split("-").map(Number);
          day = d;
          month = m;
          year = y;

          if (timePart) {
            const [h, min, sec] = timePart.split(":").map(Number);
            hour = h || 0;
            minute = min || 0;
            second = sec || 0;
          }
        }
        // Case 2: YYYY-MM-DD HH:mm:ss    e.g. 2026-01-14 12:26:33
        else if (cleaned.match(/^\d{4}-\d{1,2}-\d{1,2}/)) {
          const [datePart, timePart = "00:00:00"] = cleaned.split(/\s+/);
          const [y, m, d] = datePart.split("-").map(Number);
          year = y;
          month = m;
          day = d;

          if (timePart) {
            const [h, min, sec] = timePart.split(":").map(Number);
            hour = h || 0;
            minute = min || 0;
            second = sec || 0;
          }
        } else {
          console.warn("Unrecognized date format:", cleaned);
          return new Date(0);
        }

        // JavaScript Date months are 0-based → month - 1
        const date = new Date(year, month - 1, day, hour, minute, second);

        if (isNaN(date.getTime())) {
          console.warn("Invalid date after parsing:", cleaned);
          return new Date(0);
        }

        return date;
      };

      // For debugging — optional, you can remove later
      orders.forEach((o) => {
        const parsed = parseOrderTime(o.orderTime);
      });

      // Sort: newest first (descending)
      const sorted = orders
        .map((order) => ({
          ...order,
          _parsedTime: parseOrderTime(order.orderTime),
        }))
        .sort((a, b) => b._parsedTime - a._parsedTime);

      console.log("Latest order:", sorted[0]?.orderTime);

      // Set the most recent one
      if (sorted.length > 0) {
        setOrderedItem([sorted[0]]);
      } else {
        setOrderedItem([]);
      }
    });
  }, [showOrderCompleteFlag, cart, db.orders]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.shiftKey && (e.key === "+" || e.key === "-")) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const finalizePaymentFlow = async () => {
    console.log("Finalizing payment flow...");
    // 🔹 Update table data if dine-in
    if (localStorage.getItem("dineIn") === "Y") {
      const updatedTableData = await db.tableData.toArray();
      setTableCards(updatedTableData);
      setMainTableData(updatedTableData);

      setOcupiedTablesData(updatedTableData.filter((table) => table.statusType === "OCU" || table.statusType === "ONG"));

      setReservedTablesData(updatedTableData.filter((table) => table.statusType === "RES"));
    }

    // 🔹 SPLIT BILL FLOW
    if (isSplitBill) {
      const updatedSplits = splitCarts.filter((split) => split.splitNo !== removeSplit.splitNo);

      if (updatedSplits.length > 0) {
        const regeneratedSplits = updatedSplits.map((split) => ({
          ...split,
          payments: [],
          isSplit: "Y",
          sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
          referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
          giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
          couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
        }));

        setSplitCarts(regeneratedSplits);
        setCurrentSplitIndex(0);
        setCart(regeneratedSplits[0]);
        setSplitBillScreen(true);
      } else {
        // 🔹 No splits left
        setIsSplitBill(false);
        setSplitCarts([]);
        setCurrentSplitIndex(0);
        setKeyValue("0");
      }

      localStorage.setItem("tableName", JSON.stringify(recordState));
      return;
    }

    // 🔹 NORMAL BILL
    // processOrder();
  };

  const handleOrderCompletion = async () => {
    console.log("Handling order completion...");
    await new Promise((res) => setTimeout(res, 200));
    const updatedCart = JSON.parse(localStorage.getItem("cartObj"));
    if (!updatedCart) return;

    const paid = updatedCart.paid || 0;
    const total = parseFloat(updatedCart.total);

    // 🟡 NEW PREORDER (toggle ON)
    if (updatedCart.layAway === "Y" && !updatedCart.wasLayaway) {
      if (posConfig?.requirePaymentForAdvance === "Y" && (!paid || paid <= 0)) {
        message.warning("Minimum payment required to create advance order");
        return;
      }
      setShowOrderCompleteFlag(true);
      updatedCart.advancePayment = paid;
      updatedCart.layAway = "Y";
      updatedCart.isAdvance = "Y";
      updatedCart.preOrder = "Y";
      updatedCart.statusType = "layAway";
      localStorage.setItem("cartObj", JSON.stringify(updatedCart));
      await processOrder("layaway");
      return;
    }

    // 🟡 RETRIEVED → TOGGLE STILL ON
    if (updatedCart.wasLayaway && updatedCart.isAdvance !== "N") {
      setShowOrderCompleteFlag(true);
      updatedCart.layAway = "Y";
      updatedCart.isAdvance = "Y";
      updatedCart.statusType = "layAway"; // ⭐ syncOrders reads THIS
      updatedCart.advancePayment = paid;
      localStorage.setItem("cartObj", JSON.stringify(updatedCart));
      await processOrder("layaway");
      return;
    }

    // 🟢 RETRIEVED → TOGGLE OFF → FINISH
    if (updatedCart.wasLayaway && updatedCart.isAdvance === "N") {
      if (paid < total) {
        message.warning("Please complete the full payment before finishing the advance order");
        return;
      }
      setShowOrderCompleteFlag(true);
      updatedCart.layAway = "Y";
      updatedCart.isAdvance = "N";
      updatedCart.statusType = "";
      localStorage.setItem("cartObj", JSON.stringify(updatedCart));
      await processOrder("layaway");
      return;
    }

    // 🔵 NORMAL ORDER
    if (paid >= total) {
      console.log("Payment complete, processing order...");

      const isDineIn = localStorage.getItem("dineIn") === "Y";

      if (isDineIn) {
        // ✅ For dine-in: setShowOrderCompleteFlag is triggered inside processOrderApproved
        // after upsertTableStatus + upsertFbOrder succeed — do NOT set it here
        await finalizePaymentFlow();
      } else {
        console.log("Not dine-in, finalizing immediately...");
        // ✅ For takeaway/other: set flag immediately then finalize
        //setShowOrderCompleteFlag(true);
        await finalizePaymentFlow();
      }
    }
  };

  const renderPaymentSection = () => {
    return (
      <>
        {paymentVisible ? (
          <div>
            <Row style={{ padding: "2vh 1.5vw 0 1.5vw", fontSize: "1vw" }}>
              <Col span={24}>
                <p
                  style={{
                    fontWeight: 500,
                    paddingLeft: "3px",
                    fontSize: "1.25em",
                    color: "#0F0718",
                  }}
                >
                  <img
                    src={Back}
                    style={{
                      height: "4vh",
                      cursor: "pointer",
                      paddingBottom: "0.1em",
                    }}
                    onClick={() => {
                      // if (cart.paid > 0) {
                      //   message.warning(`${messages.errors.till_management.delete_payment_method}`);
                      //   return;
                      // }
                      setPaymentVisible(false);
                      setSelectedPayment(false);
                      setSelectedPaymentMethod({});
                    }}
                  />{" "}
                  Order Checkout
                </p>
              </Col>
            </Row>
            <Row style={{ textAlign: "center", fontSize: "1vw" }}>
              <Col
                span={24}
                style={{
                  fontSize: "1.5em",
                  color: "#0F0718",
                  fontWeight: 500,
                }}
              >
                {getMultilingualText("Amount To Pay")} {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                {(() => {
                  const total = cart.total || 0;
                  const paid = cart.paid || 0;
                  const tip = cart.tip || 0;
                  const serviceCharge = cart.serviceCharge || 0;
                  const packingCharge = cart.packingCharge || 0;
                  const deiveryCharge = cart.deiveryCharge || 0; // spelling is same as your cart object

                  // Amount To Pay calculation
                  const amountToPay = total - paid + tip + serviceCharge + packingCharge + deiveryCharge;

                  return amountToPay.toFixed(2);
                })()}
                {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
              </Col>

              <Col span={5}></Col>
              <Col span={14}>
                <Row justify="center" style={{ padding: "5% 1% 0 0%", height: "18.5vh" }} gutter={5}>
                  {_.sortBy(showPayments, "sequenceNo").map((pm, ind) => {
                    if (
                      (posConfig?.loyaltyApplicable === "N" && pm.name === "Loyalty") ||
                      (!cart?.customer?.loyaltyLevel?.cwrLoyaltyLevelId && pm.name === "Loyalty") ||
                      (!cart?.customer?.iscredit && pm.iscredit) ||
                      pm.name.toLowerCase() === "cafe tips"
                    ) {
                      return null;
                    }
                    return (
                      <Col span={6} key={pm.finPaymentmethodId}>
                        <button
                          onClick={() => {
                            if (cart.items.length > 0) {
                              // paymentModalInputRef?.current?.select();
                              // paymentModalInputRef?.current?.focus();
                              // setNumb(0);
                              setSelectedPayment(true);
                              let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails")) || {
                                orderStartTime: "",
                                orderEndTime: "",
                                paymentStartTime: "",
                              };
                              if (orderTimeDetails.paymentStartTime === "") {
                                orderTimeDetails = {
                                  ...orderTimeDetails,
                                  paymentStartTime: moment(new Date()).format(userPreferences.dateTimeFormat),
                                };
                                localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
                              }
                              if (pm.name.toLowerCase() === "card" && !pm.integratedPayment && posConfig?.enablePaymentData === "Y") {
                                setIsCardPaymentFlag(true);
                              }
                              const originalAmount = Math.abs(cart.total) - (cart.paid ?? 0);

                              const currenciesList = tillData?.tillAccess?.csBunit?.currencies?.[0]?.denominations?.sort((a, b) => a.value - b.value) || [];

                              const precision = tillData?.tillAccess?.csBunit?.currencies?.[0]?.prcPrecision || 2;

                              const smallestDenomination = currenciesList.length > 0 ? Number(currenciesList[0].value) : 1;

                              // CASH → ALWAYS RECALCULATE
                              if (pm.name.toLowerCase() === "cash" && pm.roundOffForPos === "Y" && pm.integratedPayment === false) {
                                const roundedAmount = Math.ceil(originalAmount / smallestDenomination) * smallestDenomination;

                                setAmount(Number(roundedAmount).toFixed(precision));
                              } else {
                                setAmount(Number(originalAmount).toFixed(precision));
                              }
                              setSelectedPaymentMethod(pm);
                            }
                            setTimeout(() => {
                              paymentModalInputRef.current?.focus();
                              paymentModalInputRef.current?.select();
                            }, 100);
                          }}
                          id={`sm-payment-${pm.name.toLowerCase()}`}
                          // ref={ind === 0 ? paymentCardRef : null}
                          style={{
                            backgroundColor: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#2F3856" : "#fff",
                            border: "1px solid #fff",
                            borderRadius: "7px",
                            height: "16vh",
                            width: "8.2vw",
                            cursor: "pointer",
                          }}
                          tabIndex={0}
                          onKeyPress={(e) => (e.charCode === 13 ? setSelectedPaymentMethod(pm) : null)}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "row",
                              position: "relative",
                              fontSize: "1vw",
                            }}
                          >
                            {/* {pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? (
                                  <img src={ticSelect} style={{ top: "-2vh", right: "0", height: "2.1vh", position: "absolute" }} />
                                ) : null} */}
                            <span
                              className="payment"
                              style={{
                                color: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718",
                                fontSize: "1.5em",
                              }}
                            >
                              {pm.name.toLowerCase() === "cash" ? (
                                <>
                                  {/* {currenciesList[0]
                                        ? currenciesList[0].currSymbol
                                        : ""} */}
                                  <img
                                    src={Cash1}
                                    style={{
                                      height: "3vh",
                                      marginTop: "-4vh",
                                      filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)",
                                    }}
                                    // color={pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718"}
                                  />
                                  <p
                                    style={{
                                      position: "absolute",
                                      bottom: "-7.5vh",
                                      left: "25%",
                                    }}
                                  >
                                    {pm.name}
                                  </p>
                                </>
                              ) : pm.name.toLowerCase() === "card" ? (
                                <>
                                  {/* <img
                                        src={Back}
                                        style={{ height: "2.5vh" }}
                                        color={
                                          pm.finPaymentmethodId ===
                                          selectedPaymentMethod.finPaymentmethodId
                                            ? "#fff"
                                            : "#0F0718"
                                        }
                                      /> */}
                                  <img
                                    src={Card1}
                                    style={{
                                      height: "3.5vh",
                                      marginTop: "-4vh",
                                      filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)",
                                    }}
                                    // color={pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718"}
                                  />
                                  <p
                                    style={{
                                      position: "absolute",
                                      bottom: "-7.5vh",
                                      left: "25%",
                                    }}
                                  >
                                    {pm.name}
                                  </p>
                                </>
                              ) : pm.name.toLowerCase() === "upi" ? (
                                <>
                                  <img
                                    // src={Back}
                                    src={qrCodeIcon}
                                    style={{
                                      height: "3.5vh",
                                      marginTop: "-4vh",
                                      filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)",
                                    }}
                                    // color={pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718"}
                                  />
                                  <p
                                    style={{
                                      position: "absolute",
                                      bottom: "-6.5vh",
                                      left: "30%",
                                    }}
                                  >
                                    {pm.name}
                                  </p>
                                </>
                              ) : pm.iscredit ? (
                                <>
                                  <img
                                    src={Credit}
                                    style={{
                                      height: "3vh",
                                      marginTop: "-4vh",
                                      filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)",
                                    }}
                                  />
                                  <p
                                    style={{
                                      position: "absolute",
                                      bottom: "-6.5vh",
                                      left: "15%",
                                    }}
                                  >
                                    {pm.name}
                                  </p>
                                </>
                              ) : pm.name.toLowerCase() === "loyalty" ? (
                                <>
                                  <img
                                    src={Loyality}
                                    style={{
                                      height: "2.5vh",
                                      left: "0.5em",
                                      filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)",
                                    }}
                                    // color={pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718"}
                                  />
                                  <p
                                    style={{
                                      position: "absolute",
                                      bottom: "-7.5vh",
                                      left: "25%",
                                    }}
                                  >
                                    {pm.name}
                                  </p>
                                </>
                              ) : pm.name.toLowerCase() === "gift card" ? (
                                <>
                                  <img
                                    src={Gift}
                                    style={{
                                      height: "2.5vh",
                                      marginBottom: "0.2em",
                                      filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)",
                                    }}
                                    // color={pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718"}
                                  />
                                  <p
                                    style={{
                                      position: "absolute",
                                      bottom: "-7.5vh",
                                      left: "25%",
                                    }}
                                  >
                                    {pm.name}
                                  </p>
                                </>
                              ) : pm.name.toLowerCase() === "gift voucher" ? (
                                <>
                                  <img
                                    src={giftVoucher}
                                    style={{
                                      height: "2.5vh",
                                      marginBottom: "0.2em",
                                      filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)",
                                    }}
                                    // color={pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718"}
                                  />
                                  <p
                                    style={{
                                      position: "absolute",
                                      bottom: "-7.5vh",
                                      left: "25%",
                                    }}
                                  >
                                    {pm.name}
                                  </p>
                                </>
                              ) : pm.name.toLowerCase() === "credit note" ? (
                                <>
                                  <img
                                    src={creditNote}
                                    style={{ height: "2.5vh", filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)" }}
                                    // color={pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718"}
                                  />
                                  <p
                                    style={{
                                      position: "absolute",
                                      bottom: "-7.5vh",
                                      left: "25%",
                                    }}
                                  >
                                    {pm.name}
                                  </p>
                                </>
                              ) : (
                                // ""
                                <p
                                  style={{
                                    left: "25%",
                                    textAlign: "center",
                                    margin: 0,
                                  }}
                                >
                                  {pm.name}
                                </p>
                              )}
                            </span>
                          </div>
                        </button>
                      </Col>
                    );
                  })}
                  {/* {cart.layAway === "Y" && posConfig?.advanceLayaway === "Y" ? (
                    <Col
                      span={8}
                      onClick={() => {
                        setShowOrderCompleteFlag(true);
                        processOrder("layaway");
                      }}
                    >
                      <button
                        style={{
                          backgroundColor: "#046307C2",
                          border: "1px solid #fff",
                          borderRadius: "7px",
                          height: "8.6vh",
                          width: "100%",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "row",
                          }}
                        >
                          <CheckOutlined style={{ fontSize: "3vh", color: "#fff" }} />
                        </div>
                      </button>
                    </Col>
                  ) : null} */}

                  {/* {posConfig?.advanceLayaway === "Y" && localStorage.getItem("dineIn") !== "Y" ? (
                    <Col
                      span={6}
                      onClick={() => {
                        if (posConfig?.requirePaymentForAdvance === "Y" && cart.paid <= 0) {
                          message.warning(`${messages.warnings.payment.payment_required}`);
                          return;
                        }
                        if (cart.paid <= cart.total) {
                          cart.statusType = "layAway";
                          cart.layAway = "Y";
                          localStorage.setItem("cartObj", JSON.stringify(cart));
                          const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                          const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);

                          const isCashPayment = selectedPaymentMethod?.name?.toLowerCase() === "cash";
                          const isValidCashAmount = parseFloat(amount) % 0.25 === 0;

                          if (cart?.advancePayment > 0 && parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                            if (result !== 0 && isCashPayment) {
                              message.warning(`${t("cash_payment_error")}`);
                            } else {
                              setShowOrderCompleteFlag(true);
                              processOrder("layaway");
                            }
                          } else {
                            setShowOrderCompleteFlag(true);
                            processOrder("layaway");
                          }
                        }
                      }}
                    >
                      <button
                        style={{
                          // backgroundColor: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#2F3856" : "#fff",
                          backgroundColor: "#2F3856",
                          border: "1px solid #fff",
                          borderRadius: "7px",
                          height: "16vh",
                          width: "8.2vw",
                          cursor: "pointer",
                          fontSize: "1vw",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "row",
                            color: "#fff",
                            fontSize: "1.2em",
                          }}
                        >
                          Create Advance
                        </div>
                      </button>
                    </Col>
                  ) : null} */}

                  {filteredPaymentMethods.length > 4 && (
                    <Col span={4}>
                      <button
                        // onClick={isShowingAll ? showPreviousItems : showMoreItems}
                        onClick={() => {
                          setSelectedPaymentMethod({});
                          isShowingAll ? showPreviousItems() : showMoreItems();
                        }}
                        style={{
                          backgroundColor: "#2F3856",
                          border: "1px solid #fff",
                          borderRadius: "7px",
                          height: "16vh",
                          width: "7.5vw",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "row",
                          }}
                        >
                          <img style={{ height: "2.5vh", left: "0.5em" }} color={"#fff"} />
                          <span className="payment" style={{ color: "#fff", marginLeft: "0.25em" }}>
                            ...
                          </span>
                        </div>
                      </button>
                    </Col>
                  )}
                </Row>

                <Row style={{ margin: "0 0 0 0 ", paddingTop: "10%" }}>
                  <Input
                    className="productSearch sm-payment-search totalInput"
                    style={{
                      borderRadius: "0.5vw",
                      height: "7.3vh",
                      margin: "0 1% 2.7% 3.5%",
                      borderRadius: "5px",
                      textAlign: "right",
                      fontWeight: "500",
                      fontSize: "2.5em",
                      borderColor: "#fff",
                      color: "#2F3856",
                    }}
                    // prefix={<span style={{ color: "#0F0718", fontWeight: "600" }}>Amount Tendered</span>}
                    value={amount}
                    id="sm-total-amount-input"
                    onChange={onChangeAmount}
                    placeholder="Enter Amount"
                    ref={paymentModalInputRef}
                    onFocus={() => {
                      setIsInputFocused(true);
                    }}
                    onBlur={() => {
                      setIsInputFocused(false);
                    }}
                    readOnly={cart.items.length > 0 ? false : true}
                    disabled={tillData.tillAccess.cwrTill.layAway === "Y" && tillData.tillAccess.cwrTill.payNow === "N" ? true : false}
                    onPressEnter={async () => {
                      if (!selectedPayment && paymentVisible) {
                        message.warning(`${messages.warnings.payment.select_payment_method}`);
                        return;
                      }
                      const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                      const denominationsValue = filtredCurrencies[0]?.value || 1;
                      const scale = 100; // For 2 decimal places
                      const scaledDividend = Math.round(amount * scale); // 1040
                      const scaledDivisor = Math.round(denominationsValue * scale); // 20

                      const scaledRemainder = scaledDividend % scaledDivisor;
                      const remainder = scaledRemainder / scale;
                      const isReturnFlow = selectedPaymentMethod?.isReturns === "Y";
                      const isGiftCardOrLoyalty =
                        selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
                        selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
                        selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
                      if (isGiftCardOrLoyalty && paymentVisible) {
                        if (parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                          // if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && parseFloat(amount) % 0.25 !== 0) {
                          if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && remainder !== 0) {
                            message.warning(`${messages.warnings.payment.payment_multiple_check} ${denominationsValue}`);
                          } else {
                            setNumb(0);
                            if (!isReturnFlow && cart.paid + parseFloat(amount) > cart.total.toFixed(2) && selectedPaymentMethod?.name?.toLowerCase() !== "cash") {
                              message.warn(`${messages.errors.cart.overpayment_not_allowed}`);
                              return;
                            }
                            requestPayment(selectedPaymentMethod, amount);
                            setSelectedPayment(false);
                            if (localStorage.getItem("dineIn") === "Y") {
                              console.log("Marking table bill as requested...");
                              await markTableBillRequested();
                            }
                            await handleOrderCompletion(amount);
                          }
                        } else {
                          setShowOrderCompleteFlag(true);
                          processOrder();
                        }
                      } else if (paymentVisible === false) {
                        setPaymentVisible(true);
                      }
                    }}
                  />
                </Row>
                {denaminationsKeyboard && selectedPaymentMethod?.name?.toLowerCase() === "cash" ? (
                  <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
                    <Col span={18}>
                      <Row gutter={[8, 6]} style={{ display: "flex", flexDirection: "row" }}>
                        {currenciesData
                          .sort((a, b) => b.seqNo - a.seqNo)
                          .slice(showAll ? 11 : 0, showAll ? currenciesData.length : 11)
                          .map((currency, index) => (
                            <Col span={8} key={index}>
                              <button
                                id={`sm-amount-button${index + 1}`}
                                className="amt-dial-btn-restaurant"
                                onClick={() => handleCashPayment(currency.value)}
                                disabled={currency.value === 999999}
                                style={{
                                  color: currency.value !== 999999 ? "#0f0718" : "transparent",
                                }}
                              >
                                {currency.value}
                              </button>
                            </Col>
                          ))}
                        {currenciesData.length > 12 && (
                          <Col span={8}>
                            <button id="sm-amount-buttonMore" className="amt-dial-btn-restaurant" onClick={() => setShowAll(!showAll)}>
                              {showAll ? "Back" : "More..."}
                            </button>
                          </Col>
                        )}
                      </Row>
                    </Col>
                    <Col span={6}>
                      <Row style={{ padding: "0 0 7% 7%" }}>
                        <button className="amt-dial-btn-restaurant" id="sm-amount-buttonRemove" onClick={() => handleAmount("x")}>
                          <img src={CancelArrow} alt="back space" width={width <= 1024 ? 20 : 25} height={width <= 1024 ? 15 : 15} />
                        </button>
                      </Row>
                      <Row style={{ padding: "0 0 7% 7%" }}>
                        <button id="sm-amount-buttonClear" className="amt-dial-btn-restaurant" onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}>
                          1,2,3...
                        </button>
                      </Row>
                      <Row style={{ padding: "0 0 0 7%" }}>
                        <button
                          id="sm-amount-buttonEnter"
                          className="amt-dial-btn-restaurant-ent"
                          style={{
                            background: isProcessing ? "#ccc" : themeJSON?.keyBoardColor,
                            cursor: isProcessing ? "not-allowed" : "pointer",
                            opacity: isProcessing ? 0.6 : 1,
                          }}
                          onClick={async () => {
                            if (isProcessing) return;

                            try {
                              setIsProcessing(true);
                              if (!selectedPayment && paymentVisible) {
                                message.warning(`${messages.warnings.payment.select_payment_method}`);
                                return;
                              }
                              const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                              const denominationsValue = filtredCurrencies[0]?.value || 1;
                              const scale = 100; // For 2 decimal places
                              const scaledDividend = Math.round(amount * scale); // 1040
                              const scaledDivisor = Math.round(denominationsValue * scale); // 20

                              const scaledRemainder = scaledDividend % scaledDivisor;
                              const remainder = scaledRemainder / scale;
                              const isReturnFlow = selectedPaymentMethod?.isReturns === "Y";
                              const isGiftCardOrLoyalty =
                                selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
                                selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
                                selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
                              if (isGiftCardOrLoyalty && paymentVisible) {
                                if (parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                                  // if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && parseFloat(amount) % 0.25 !== 0) {
                                  if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && remainder !== 0) {
                                    message.warning(`${messages.warnings.payment.payment_multiple_check} ${denominationsValue}`);
                                  } else {
                                    setNumb(0);
                                    if (!isReturnFlow && cart.paid + parseFloat(amount) > cart.total.toFixed(2) && selectedPaymentMethod?.name?.toLowerCase() !== "cash") {
                                      message.warn(`${messages.errors.cart.overpayment_not_allowed}`);
                                      return;
                                    }
                                    requestPayment(selectedPaymentMethod, amount);
                                    setSelectedPayment(false);
                                    if (localStorage.getItem("dineIn") === "Y") {
                                      console.log("Marking table bill as requested...");
                                      await markTableBillRequested();
                                    }
                                    await handleOrderCompletion(amount);
                                  }
                                } else {
                                  setShowOrderCompleteFlag(true);
                                  processOrder();
                                }
                              } else if (paymentVisible === false) {
                                setPaymentVisible(true);
                              }
                            } catch (error) {
                              console.error("Payment Error:", error);
                            } finally {
                              setIsProcessing(false);
                            }
                          }}
                        >
                          Enter
                        </button>
                      </Row>
                    </Col>
                  </Row>
                ) : (
                  <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
                    <Col span={6}>
                      <button id="sm-amount-button1" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("1")}>
                        1
                      </button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button2" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("2")}>
                        2
                      </button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button3" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("3")}>
                        3
                      </button>
                    </Col>
                    <Col span={6}>
                      <button className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} id="sm-amount-buttonRemove" onClick={() => handleAmount("x")}>
                        <img src={CancelArrow} alt="back space" width={25} height={15} />
                      </button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button4" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("4")}>
                        4
                      </button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button5" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("5")}>
                        5
                      </button>
                    </Col>
                    <Col span={6}>
                      <button id="sm-amount-button6" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("6")}>
                        6
                      </button>
                    </Col>
                    <Col span={6}>
                      <button
                        id="sm-amount-buttonClear"
                        className="amt-dial-btn-restaurant"
                        style={{ background: themeJSON?.keyBoardColor }}
                        onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}
                      >
                        1,2,3...
                      </button>
                    </Col>

                    <Col span={18}>
                      <Row gutter={[8, 6]}>
                        <Col span={8}>
                          <button id="sm-amount-button7" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("7")}>
                            7
                          </button>
                        </Col>
                        <Col span={8}>
                          <button id="sm-amount-button8" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("8")}>
                            8
                          </button>
                        </Col>
                        <Col span={8}>
                          <button id="sm-amount-button0" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("9")}>
                            9
                          </button>
                        </Col>
                        <Col span={8}>
                          <button id="sm-amount-button0" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("0")}>
                            0
                          </button>
                        </Col>
                        <Col span={8}>
                          <button id="sm-amount-button00" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("00")}>
                            00
                          </button>
                        </Col>
                        <Col span={8}>
                          <button id="sm-amount-button." className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount(".")}>
                            .
                          </button>
                        </Col>
                      </Row>
                    </Col>

                    <Col span={6}>
                      <button
                        id="sm-amount-buttonEnter"
                        className="amt-dial-btn-restaurant-ent"
                        style={{
                          background: themeJSON?.keyBoardColor,
                          background: isProcessing ? "#ccc" : themeJSON?.keyBoardColor,
                          cursor: isProcessing ? "not-allowed" : "pointer",
                          opacity: isProcessing ? 0.6 : 1,
                        }}
                        onClick={async () => {
                          if (isProcessing) return;

                          try {
                            setIsProcessing(true);
                            if (!selectedPayment && paymentVisible) {
                              message.warning(`${messages.warnings.payment.select_payment_method}`);
                              return;
                            }
                            const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                            const denominationsValue = filtredCurrencies[0]?.value || 1;
                            const scale = 100; // For 2 decimal places

                            const scaledDividend = Math.round(amount * scale); // 1040
                            const scaledDivisor = Math.round(denominationsValue * scale); // 20

                            const scaledRemainder = scaledDividend % scaledDivisor;
                            const remainder = scaledRemainder / scale;
                            const isReturnFlow = selectedPaymentMethod?.isReturns === "Y";

                            const isGiftCardOrLoyalty =
                              selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
                              selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
                              selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
                            if (isGiftCardOrLoyalty && paymentVisible) {
                              if (parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                                // if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && parseFloat(amount) % 0.25 !== 0) {
                                if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && remainder !== 0) {
                                  message.warning(`${messages.warnings.payment.payment_multiple_check} ${denominationsValue}`);
                                } else {
                                  setNumb(0);
                                  if (!isReturnFlow && cart.paid + parseFloat(amount) > cart.total.toFixed(2) && selectedPaymentMethod?.name?.toLowerCase() !== "cash") {
                                    message.warn(`${messages.errors.cart.overpayment_not_allowed}`);
                                    return;
                                  }
                                  requestPayment(selectedPaymentMethod, amount);
                                  if (localStorage.getItem("dineIn") === "Y") {
                                    console.log("Marking table bill as requested...");
                                    await markTableBillRequested();
                                  }
                                  await handleOrderCompletion(amount);
                                }
                              } else {
                                setShowOrderCompleteFlag(true);
                                processOrder();
                              }
                            } else if (paymentVisible === false) {
                              setPaymentVisible(true);
                            }
                          } catch (error) {
                            console.error("Payment Error:", error);
                          } finally {
                            setIsProcessing(false);
                          }
                        }}
                      >
                        Enter
                      </button>
                    </Col>
                  </Row>
                )}
              </Col>
              <Col span={5}></Col>
            </Row>
          </div>
        ) : (
          <div>
            <Row style={{ padding: "1.5em 1.5em 0 1.5em", fontSize: "1vw" }}>
              <Col span={12}>
                <span
                  style={{
                    paddingRight: "1vw",
                    color: "#0F0718",
                    fontSize: "1.8em",
                    fontWeight: 500,
                  }}
                >
                  Orders History
                </span>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "0.6vw",
                }}
              >
                {/* SEARCH INPUT (reduced width) */}
                <Input
                  ref={searchCustomersRef}
                  placeholder="Search for Customers/Document Number/Contact"
                  prefix={<img src={CustomerSearch} style={{ width: "1.4em" }} alt="" />}
                  style={{
                    width: "30vw",
                  }}
                  allowClear={false}
                  onPressEnter={async (e) => {
                    setLoading(true);
                    try {
                      localStorage.setItem("dataLength", "0"); // Reset pagination
                      setFiltersFlag(false); // Reset filtersFlag
                      if (e.target.value !== "") {
                        await searchOrderHistory("customer", e.target.value, 0, false, dateRange?.length > 0);
                      } else if (dateRange?.length > 0) {
                        await searchOrderHistory("orderDateSearchKey", dateRange, 0, false);
                      } else {
                        setOrderHistoryDetails([...ordersCopy]);
                        setFiltersFlag(false);
                      }
                    } catch (error) {
                      console.error("Error during search:", error);
                      message.error("Failed to search order history");
                    } finally {
                      setLoading(false);
                    }
                  }}
                  onBlur={() => {
                    setIsInputFocused(false);
                  }}
                  value={searchHistoryInput}
                  id="sm-salesHistory-customer"
                  onFocus={() => {
                    setIsInputFocused(true);
                  }}
                  className="salesHistory-input-sm"
                  onChange={(e) => {
                    const inputVal = e.target.value;
                    setSearchhistoryInput(inputVal);
                    if (inputVal === "") {
                      setOrderHistoryDetails(ordersCopy);
                      setFiltersFlag(false);
                    }
                  }}
                />
                {/* STATUS DROPDOWN */}
                <Select
                  value={orderStatusFilter}
                  onChange={(val) => setOrderStatusFilter(val)}
                  className="salesHistory-status-dropdown"
                  style={{
                    width: "11vw", // 👈 slightly bigger
                    color: "rgba(0,0,0,0.45)",
                  }}
                  dropdownStyle={{ fontSize: "0.9vw" }}
                >
                  <Option value="All Status">All Status</Option>
                  <Option value="Pending">Pending</Option>
                  <Option value="Completed">Completed</Option>
                  <Option value="Cancelled">Cancelled</Option>
                </Select>
              </Col>
            </Row>
            <Scrollbars autoHide style={{ height: "90vh" }} ref={scrollbarsRef}>
              <Row
                style={{
                  marginTop: "1vh",
                  paddingLeft: "1vw",
                  paddingRight: "1vw",
                }}
              >
                {[...orderHistoryDetails]
                  .sort((a, b) => {
                    const aDoc = a.documentno?.replace(/\D/g, "") || "0";
                    const bDoc = b.documentno?.replace(/\D/g, "") || "0";
                    return parseInt(bDoc) - parseInt(aDoc);
                  })
                  .map((orderData) => {
                    const dineText = orderData?.saleType?.name || "";
                    const dineColor = orderColors[orderData.sOrderID] || "#000";

                    return (
                      <Col span={24} style={{ padding: "0.8vh 0" }}>
                        <Card
                          style={{
                            borderRadius: "10px",
                            border: "1px solid #eee",
                            padding: "2vh 1.2vw", // 🔼 increased height
                            cursor: "pointer",
                          }}
                          bodyStyle={{ padding: 0 }}
                          onClick={async () => {
                            setLoading(true);
                            const fetchedData = await getSalesHistoryData(orderData.sOrderID);
                            if (fetchedData && fetchedData.length > 0) {
                              setSelectedOrder(fetchedData[0]);
                              console.log("fetchedData[0]", fetchedData[0], selectedOrder);
                              setSalesHistoryDrawer(true);
                            }
                            setLoading(false);
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            {/* LEFT */}
                            <div>
                              <div style={{ display: "flex", alignItems: "center", gap: "0.6vw" }}>
                                <span
                                  style={{
                                    fontSize: "1.1em",
                                    fontWeight: 600,
                                    color: "#0F0718",
                                  }}
                                >
                                  {orderData?.documentno}
                                </span>

                                <span
                                  style={{
                                    background: dineColor,
                                    color: "#fff",
                                    padding: "0.3em 0.7em",
                                    borderRadius: "12px",
                                    fontSize: "0.75em",
                                    fontWeight: 500,
                                  }}
                                >
                                  {dineText}
                                </span>
                              </div>

                              <div
                                style={{
                                  marginTop: "0.6vh",
                                  fontSize: "0.9em",
                                  color: "#929098",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.6vw",
                                }}
                              >
                                <span>
                                  {orderData?.customer?.name || ""} • {orderData?.orderTime?.split(" ")[0] || ""}
                                </span>

                                {/* TIME */}
                                <span>{orderData?.orderTime?.split(" ")[1] || ""}</span>
                              </div>
                            </div>

                            {/* RIGHT */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "1vw",
                              }}
                            >
                              <div style={{ textAlign: "right" }}>
                                <div
                                  style={{
                                    fontSize: "1.1em",
                                    fontWeight: 600,
                                    color: "#0F0718",
                                  }}
                                >
                                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""} {orderData?.total || 0}{" "}
                                  {currenciesList[0].symbolRightSide === "N" ? `${currenciesList[0].currSymbol} ` : ""}
                                </div>

                                <div
                                  style={{
                                    fontSize: "0.85em",
                                    color: "#929098",
                                  }}
                                >
                                  {orderData?.totalQty || 0} items
                                </div>
                              </div>

                              {/* ➜ ARROW */}
                              <RightOutlined
                                style={{
                                  fontSize: "0.9em",
                                  color: "#929098",
                                }}
                              />
                            </div>
                          </div>
                        </Card>
                      </Col>
                    );
                  })}
              </Row>
              {filtersFlag && orderHistoryDetails.length > 0 && (
                <div style={{ textAlign: "center", padding: "2vh 0" }}>
                  <Text style={{ fontSize: "1em", color: "#929098" }}>{t("No more records to load")}</Text>
                </div>
              )}
              <Drawer
                title={null}
                placement="right"
                onClose={() => {
                  setSalesHistoryDrawer(false);
                }}
                headerStyle={{ background: "white", borderBottom: "none" }}
                bodyStyle={{ padding: "1.5rem", background: "#f3f4f6" }}
                visible={salesHistoryDrawer}
                width="62%"
                closable={false}
                maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}
              >
                {selectedOrder && (
                  <>
                    {loading && (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          backgroundColor: "rgba(255,255,255,0.5)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: 9999,
                        }}
                      >
                        <Spin size="large" />
                      </div>
                    )}

                    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                      {/* HEADER */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <Title level={4} style={{ margin: 0, fontSize: "22px", fontWeight: 600 }}>
                          Order {selectedOrder.documentno}
                        </Title>

                        <Button
                          type="text"
                          icon={<CloseOutlined />}
                          onClick={() => {
                            setSelectedOrder(null);
                            setSalesHistoryDrawer(false);
                          }}
                          style={{ border: "none", boxShadow: "none" }}
                        />
                      </div>

                      {/* CUSTOMER + TIME */}
                      <div style={{ marginBottom: "18px", color: "#666" }}>
                        {selectedOrder.customer?.name || "Walk In Customer"} • {selectedOrder.orderTime}
                      </div>

                      {/* ORDER TOTAL CARD */}
                      <div
                        style={{
                          border: "1px solid #e6e6e6",
                          borderRadius: "10px",
                          padding: "10px",
                          marginBottom: "10px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <div style={{ fontSize: "13px", color: "#777" }}>Order Total</div>
                          <div style={{ fontSize: "18px", fontWeight: 600 }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {selectedOrder.total}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                          </div>
                        </div>

                        {/* SALE TYPE BADGE */}
                        <Tag
                          style={{
                            background: "#f3f4f6",
                            color: "#2f3856",
                            border: "1px solid #e6e6e6",
                            borderRadius: "12px",
                            padding: "4px 12px",
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          {selectedOrder.saleType?.name}
                        </Tag>
                      </div>

                      {/* ITEMS TITLE */}
                      <Title level={5} style={{ marginBottom: "12px" }}>
                        Ordered Items
                      </Title>

                      {/* ITEMS LIST */}
                      <div style={{ flex: 1, overflow: "auto", paddingRight: "4px" }}>
                        <Space direction="vertical" style={{ width: "100%" }} size={12}>
                          {selectedOrder.items?.map((item, index) => {
                            const alreadyReturned = item.returnQty >= item.qty;
                            return (
                              <div
                                key={index}
                                style={{
                                  border: "1px solid #e6e6e6",
                                  borderRadius: "10px",
                                  padding: "14px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                {/* LEFT */}
                                <div>
                                  <div style={{ fontSize: "15px", fontWeight: 600 }}>{item?.productAliasName ? item?.productAliasName : item.name}</div>
                                  <div style={{ fontSize: "13px", color: "#777", marginTop: "4px" }}>
                                    Qty: {item.qty} × {item.salePrice}
                                  </div>
                                </div>

                                {/* RIGHT */}
                                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                  <div style={{ fontSize: "15px", fontWeight: 600 }}>
                                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                    {item.salePrice}
                                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                  </div>

                                  {parseFloat(selectedOrder?.total) > 0 && posConfig?.showSalesReturn === "Y" && selectedOrder?.layAway === "N" && selectedOrder?.paid !== 0 && (
                                    <Button
                                      disabled={alreadyReturned}
                                      icon={<UndoOutlined />}
                                      style={{
                                        borderRadius: "6px",
                                        border: "1px solid #d9d9d9",
                                        background: alreadyReturned ? "#ccc" : "#2f3856",
                                        color: "#fff",
                                        height: "32px",
                                        padding: "0 14px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "2px",
                                      }}
                                      onClick={async () => {
                                        setLoading(true);

                                        const orderData = await searchReturnHistory(selectedOrder.documentno, selectedOrder);

                                        setLoading(false);
                                        if (!orderData) return;

                                        const line = orderData.line.find((l) => l.sOrderlineID === item.sOrderlineID);

                                        if (!line) return;

                                        const remainingQty = line.returnQty > 0 ? line.qty - line.returnQty : line.qty;

                                        if (remainingQty <= 0) {
                                          message.warning("Already fully returned");
                                          return;
                                        }

                                        setReturnItem({
                                          ...line,
                                          name: line.product?.name,
                                          salePrice: line.grossstd,
                                          remainingQty,
                                        });
                                        setReturnQty(remainingQty);

                                        const row = {
                                          ...line,
                                          key: "0",
                                          qtyToReturn: remainingQty,
                                          remainingQty,
                                        };

                                        setDataSource([row]);
                                        setSelectedReturnOrder({
                                          line: [row],
                                          cwrB2cCustomer: orderData.cwrB2cCustomer,
                                          documentno: orderData.documentno,
                                        });

                                        setCheckedKeys([row.key]);
                                        setReturnDrawerOpen(true);
                                      }}
                                    >
                                      {alreadyReturned ? "Returned" : "Return"}
                                    </Button>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </Space>
                      </div>

                      {/* FOOTER */}
                      <div
                        style={{
                          padding: "16px 10px",
                          borderTop: "1px solid #f0f0f0",
                          display: "flex",
                          gap: "12px",
                          marginTop: "12px",
                        }}
                      >
                        <Button
                          icon={<PrinterOutlined />}
                          style={{
                            flex: 1,
                            height: "40px",
                            borderRadius: "6px",
                          }}
                          onClick={async () => {
                            const { workflowRules, approvers } = await getWorkflowData();
                            if (workflowRules && workflowRules.length > 0) {
                              workflowRules.forEach((res) => {
                                if (res.eventName === "Receipt Reprint Request") {
                                  dispatchEvent(res.eventName, res.ruleName, res.ruleCondition, approvers, null, (eventData) => {
                                    if (eventData?.approvalGranted) {
                                      ObFlag
                                        ? HCPrint(selectedOrder, "Duplicate Copy")
                                        : CWHardwareController
                                          ? CWHCPrint(selectedOrder, "Duplicate Copy")
                                          : isPrintModeXML
                                            ? xmlPrint(selectedOrder, "Duplicate Copy")
                                            : htmlPrint(selectedOrder, "Duplicate Copy");
                                    }
                                  });
                                }
                              });
                            } else {
                              ObFlag
                                ? HCPrint(selectedOrder, "Duplicate Copy")
                                : CWHardwareController
                                  ? CWHCPrint(selectedOrder, "Duplicate Copy")
                                  : isPrintModeXML
                                    ? xmlPrint(selectedOrder, "Duplicate Copy")
                                    : htmlPrint(selectedOrder, "Duplicate Copy");

                              upsertPOSLog(selectedOrder, "RRC");
                            }
                          }}
                        >
                          Reprint
                        </Button>
                      </div>
                    </div>
                  </>
                )}
              </Drawer>
              <Drawer
                placement="right"
                width="62%"
                visible={returnDrawerOpen}
                onClose={() => setReturnDrawerOpen(false)}
                closable={false}
                headerStyle={{ background: "#f3f4f6", borderBottom: "none" }} // ⭐ FIX
                bodyStyle={{ padding: "1.5rem", paddingTop: "0", background: "#f3f4f6" }}
                maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}
                title={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      paddingTop: "15px",
                      background: "#f3f4f6", // ⭐ ensure title bg same
                    }}
                  >
                    <div>
                      <div style={{ fontSize: "22px", fontWeight: 600, color: "#2f3856", marginBottom: "5px" }}>Return Item</div>
                      <div style={{ fontSize: "14px", color: "#666" }}>Process return for {returnItem?.name}</div>
                    </div>

                    <img src={Close} onClick={() => setReturnDrawerOpen(false)} style={{ cursor: "pointer", width: 16, height: 18 }} />
                  </div>
                }
              >
                {returnItem && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                    }}
                  >
                    {/* ITEM CARD */}
                    <div
                      style={{
                        border: "1px solid #e6e6e6",
                        borderRadius: "10px",
                        padding: "14px",
                        marginBottom: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <div style={{ fontSize: "15px", fontWeight: 600 }}>{returnItem?.product?.name || returnItem?.name}</div>
                        <div style={{ fontSize: "13px", color: "#777" }}>
                          Qty: {returnItem?.qty} × {returnItem?.grossstd || returnItem?.salePrice}
                        </div>
                      </div>

                      <div style={{ fontSize: "15px", fontWeight: 600 }}>
                        {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""} {returnItem.salePrice}{" "}
                        {currenciesList[0].symbolRightSide === "N" ? `${currenciesList[0].currSymbol} ` : ""}
                      </div>
                    </div>

                    {/* RETURN QTY */}
                    <div style={{ marginBottom: "10px" }}>
                      <div style={{ fontSize: "14px", fontWeight: 500, marginBottom: "6px" }}>Return Quantity</div>

                      <Select value={returnQty} onChange={setReturnQty} style={{ width: "100%" }}>
                        {Array.from({ length: returnItem.remainingQty }, (_, i) => (
                          <Select.Option key={i + 1} value={i + 1}>
                            {i + 1}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>

                    {/* RETURN TYPE */}
                    <div style={{ marginBottom: "10px" }}>
                      <div style={{ fontSize: "14px", fontWeight: 500, marginBottom: "8px" }}>Return Type</div>

                      <Radio.Group value={returnType} onChange={(e) => setReturnType(e.target.value)} style={{ width: "100%" }}>
                        {/* WASTAGE */}
                        <div
                          style={{
                            border: "1px solid #e6e6e6",
                            borderRadius: "10px",
                            padding: "12px 14px",
                            marginBottom: "10px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Radio value="wastage">Wastage</Radio>

                          <span
                            style={{
                              background: "#f3f4f6",
                              fontSize: "12px",
                              padding: "2px 8px",
                              borderRadius: "6px",
                            }}
                          >
                            Default
                          </span>
                        </div>

                        {/* STOCK */}
                        <div
                          style={{
                            border: "1px solid #e6e6e6",
                            borderRadius: "10px",
                            padding: "12px 14px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Radio value="stock">Add Back to Stock</Radio>

                          <span style={{ fontSize: "12px", color: "#f59e0b" }}>Requires Approval</span>
                        </div>
                      </Radio.Group>
                    </div>

                    {/* REASON */}
                    <div style={{ marginBottom: "18px" }}>
                      <div style={{ fontSize: "14px", fontWeight: 500, marginBottom: "6px" }}>Reason Code *</div>

                      <Select
                        value={reasonCode}
                        onChange={(val) => {
                          setReasonCode(val);
                          setReasonError(false); // clear error when selected
                        }}
                        placeholder="Select a reason"
                        style={{
                          width: "100%",
                          border: reasonError ? "1px solid #ff4d4f" : undefined,
                          borderRadius: 6,
                        }}
                      >
                        {returnReasons.map((reason) => (
                          <Select.Option key={reason} value={reason}>
                            {reason}
                          </Select.Option>
                        ))}
                      </Select>

                      {reasonError && (
                        <div
                          style={{
                            color: "#ff4d4f",
                            fontSize: "12px",
                            marginTop: "6px",
                          }}
                        >
                          Please select a reason code
                        </div>
                      )}
                    </div>

                    {/* NOTES */}
                    <div style={{ marginBottom: "30px" }}>
                      <div style={{ fontSize: "14px", fontWeight: 500, marginBottom: "6px" }}>Additional Notes (Optional)</div>

                      <Input.TextArea rows={2} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Enter any additional notes..." />
                    </div>
                    <div
                      style={{
                        position: "sticky",
                        bottom: 0,
                        background: "#f3f4f6",
                        padding: "0",
                        borderTop: "1px solid #e6e6e6",
                      }}
                    >
                      <div style={{ display: "flex", gap: "12px" }}>
                        <Button
                          style={{
                            flex: 1,
                            height: "48px",
                            borderRadius: "8px",
                            fontWeight: 500,
                          }}
                          onClick={() => setReturnDrawerOpen(false)}
                        >
                          Cancel
                        </Button>

                        <Button
                          style={{
                            flex: 1,
                            height: "48px",
                            borderRadius: "8px",
                            background: "#111",
                            color: "#fff",
                            border: "none",
                            fontWeight: 500,
                          }}
                          onClick={handleProcessReturn}
                        >
                          Process Return
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </Drawer>
              <Modal visible={approvalVisible} onCancel={() => setApprovalVisible(false)} footer={null} centered width={420}>
                <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 6 }}>Approval Required</div>

                <div style={{ fontSize: 13, color: "#666", marginBottom: 16 }}>
                  Adding items back to stock requires manager approval. This action will be recorded for audit purposes.
                </div>

                <div
                  style={{
                    background: "#f3f4f6",
                    borderRadius: 8,
                    padding: 12,
                    marginBottom: 20,
                    fontSize: 13,
                  }}
                >
                  <div>Item: {returnItem?.name}</div>
                  <div>Quantity: {returnQty}</div>
                  <div>Reason: {reasonCode}</div>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                  <Button onClick={() => setApprovalVisible(false)}>Cancel</Button>

                  <Button
                    type="primary"
                    style={{ background: "#111", border: "none" }}
                    onClick={() => {
                      setApprovalVisible(false);
                      submitReturn(); // 🔥 final submit
                    }}
                  >
                    Approve & Process
                  </Button>
                </div>
              </Modal>
            </Scrollbars>
          </div>
        )}
      </>
    );
  };

  const getDefaultSaleType = async () => {
    const saleData = await db.posSaletypes.toArray();
    const defaultSale = saleData.find((sale) => sale?.cwrSaletype?.isdefault === "Y");
    if (defaultSale) {
      return defaultSale;
    }
    if (saleType === "DI") {
      const dineInSale = saleData.find((sale) => sale?.cwrSaletype?.fulfilmentType === "DI");
      if (dineInSale) {
        return dineInSale;
      }
    } else if (saleType === "TA") {
      const takeAwaySale = saleData.find((sale) => sale?.cwrSaletype?.fulfilmentType === "TA");
      if (takeAwaySale) {
        return takeAwaySale;
      }
    }
    return undefined;
  };
  const tableData = JSON.parse(localStorage.getItem("tableName"));
  const guestName = tableData?.guestName || "";

  const markTableBillRequested = async () => {
    console.log("Marking table as Bill Requested...");
    // current table info is already stored in localStorage
    const tableInfo = JSON.parse(localStorage.getItem("tableName") || "null");
    if (!tableInfo?.cwrFbTableId) return;

    const tableRecord = await db.tableData.where("cwrFbTableId").equals(tableInfo.cwrFbTableId).first();

    if (!tableRecord) return;

    // update local table status
    tableRecord.statusType = "BRQ"; // 🔹 Bill Requested
    tableRecord.tableSync = "N";

    await db.tableData.put(tableRecord, tableRecord.cwrFbTableId);

    // sync to server
    await SyncData(tableRecord, "upsertTableStatus");

    // update UI state (if you keep tableCards / tableList in state)
    setTableCards((prev) => prev.map((t) => (t.cwrFbTableId === tableRecord.cwrFbTableId ? { ...t, ...tableRecord } : t)));
    setTableList?.((prev) => prev.map((t) => (t.cwrFbTableId === tableRecord.cwrFbTableId ? { ...t, ...tableRecord } : t)));
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
          }}
        >
          <Spin size="large" />
        </div>
      )}
      {showOrderCompleteFlag ? (
        <div style={{ width: "100%", height: "100vh", padding: "2vh 1vw" }}>
          <Row gutter={[16]}>
            <Col
              span={12}
              style={{
                width: "100%",
                height: "96vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20vh 6vw 20vh 5vw",
                flexDirection: "column",
                fontSize: "1vw",
              }}
            >
              <div
                style={{
                  fontSize: "2em",
                  paddingBottom: "4vh",
                  fontWeight: 600,
                  color: "#0F0718",
                }}
              >
                {getMultilingualText("")} <img src={paymentSuccess} style={{ height: "4rem" }} />
              </div>
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Order No")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {OrderedItem[0]?.documentno}
                </Text>
              </Space>
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Payment Method")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {/* {OrderedItem[0]?.payments[0]?.name} */}
                  {OrderedItem[0]?.payments.map((payment, index) => (
                    <span key={index}>
                      {payment.name}
                      {index < OrderedItem[0]?.payments.length - 1 && ", "}
                    </span>
                  ))}
                </Text>
              </Space>
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Total Items")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {OrderedItem[0]?.totalQty}
                </Text>
              </Space>
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Subtotal")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {(OrderedItem[0]?.total - OrderedItem[0]?.tax).toFixed(2)}
                </Text>
              </Space>
              {/* <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  Discount Sales
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  -4
                </Text>
              </Space> */}
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Total Sal Tax")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {typeof OrderedItem[0]?.tax === "number" && OrderedItem[0].tax % 1 !== 0 ? parseFloat(OrderedItem[0].tax.toFixed(2)) : OrderedItem[0]?.tax}
                </Text>
              </Space>
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 600,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Total Amount")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 600,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {OrderedItem[0]?.total}
                  {/* {parseFloat(OrderedItem[0]?.total - OrderedItem[0]?.discount).toFixed(2)} */}
                </Text>
              </Space>
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 600,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Amount Paid")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 600,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {OrderedItem[0]?.payments
                    .reduce((sum, p) => sum + parseFloat(p.name.toLowerCase() === "cash" ? OrderedItem[0]?.tenderedAmount || p.amount : p.amount || 0), 0)
                    .toFixed(2)}
                </Text>
              </Space>
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 600,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Change")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 600,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {OrderedItem[0]?.payments.some((p) => p.name.toLowerCase() === "cash")
                    ? parseFloat((OrderedItem[0]?.tenderedAmount || 0) - (OrderedItem[0]?.payments.find((p) => p.name.toLowerCase() === "cash")?.amount || 0)).toFixed(2)
                    : (0).toFixed(2)}
                </Text>
              </Space>
            </Col>
            <Col
              span={12}
              style={{
                width: "100%",
                height: "96vh",
                backgroundColor: "#fff",
                borderRadius: "15px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1vw",
              }}
            >
              <Text
                style={{
                  color: "#0F0718",
                  fontSize: "1.75em",
                  paddingBottom: "8vh",
                  fontWeight: 500,
                }}
              >
                How would you like your receipt ?{multilingual && <div style={{ display: "block" }}>{t("How would you like your receipt ?")}</div>}
              </Text>

              <Space direction="vertical" size="large">
                <Button
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#2F3856",
                    height: "7.5vh",
                    color: "#fff",
                    fontSize: "1em",
                    fontWeight: 500,
                    width: "23vw",
                  }}
                  onClick={printReceipt()}
                >
                  {getMultilingualText("Print Receipt")}
                </Button>

                {splitCarts.length > 0 ? (
                  <Button
                    style={{
                      borderRadius: "10px",
                      backgroundColor: "#fff",
                      border: "1px solid #92909880",
                      height: "7.5vh",
                      color: "#2F3856",
                      fontSize: "1em",
                      fontWeight: 500,
                      width: "23vw",
                    }}
                    onClick={() => {
                      setShowOrderCompleteFlag(false);
                      setPaymentVisible(false);
                    }}
                  >
                    Other Splits
                  </Button>
                ) : (
                  <Button
                    style={{
                      borderRadius: "10px",
                      backgroundColor: "#fff",
                      height: "7.5vh",
                      color: "#0F0718",
                      fontWeight: 500,
                      fontSize: "1em",
                      width: "23vw",
                    }}
                    onClick={async () => {
                      setSelectedSaleTypeIndex(null);
                      const defaultSaleType = await getDefaultSaleType();
                      if (!defaultSaleType) {
                        console.warn("No sale type found");
                        return;
                      }
                      const defaultIndex = Array.isArray(sortedSaleTypes)
                        ? sortedSaleTypes.findIndex((st) => st?.cwrSaletype?.fulfilmentType === defaultSaleType?.cwrSaletype?.fulfilmentType)
                        : -1;

                      if (defaultIndex !== -1) {
                        setSelectedSaleTypeIndex(defaultIndex);
                      }
                      setSelectedSaleType(defaultSaleType.cwrSaletype.name);
                      setSelectedSaleTypeData(defaultSaleType);
                      const cartData = {
                        items: [],
                        couponInput: [],
                        total: 0,
                        tax: 0,
                        discount: 0,
                        paid: 0,
                        change: 0,
                        totalQty: 0,
                        roundOff: 0,
                        payments: [],
                        redemptionPoints: 0,
                        accumulationPoints: 0,
                        creditAmount: 0,
                        sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
                        referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
                        giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                        couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                        customer: defaultSaleType.customer?.b2cCustomerId ? defaultSaleType.customer : tillData.tillAccess.csBunit.b2cCustomer,
                        salesRepId: null,
                        cardPaymentData: {},
                        documentno: `${tillData?.tillAccess?.cwrTill?.prefix}${parseFloat(localStorage.getItem("documentSequence")) + 1}`,
                        userName: userData.user,
                        tillName: tillValue?.name,
                        subTotal: 0,
                        itemsSummery: {},
                        amountInWords: "",
                        groupedItemsByTaxRate: {},
                        serviceCharge: 0,
                        tip: 0,
                        deiveryCharge: 0,
                        packingCharge: 0,
                        guestName: "",
                        noOfGuests: 0,
                      };
                      setCart(cartData);
                      localStorage.setItem("cartObj", JSON.stringify(cartData));
                      setSplitBillScreen(false);
                      setShowSendToKitchen(false);
                      setSplitCarts([]);
                      localStorage.setItem("dineIn", "Y");
                      setKeyValue("0");
                      setShowOrderCompleteFlag(false);
                      setPaymentVisible(false);
                      setShowProducts(false);
                      const type = defaultSaleType?.cwrSaletype?.fulfilmentType;
                      if (type === "TA") {
                        localStorage.setItem("dineIn", "N");
                        setKeyValue("2");
                      } else if (type === "DI") {
                        localStorage.setItem("dineIn", "Y");
                        setKeyValue("0");
                        const updatedTableData = await db.tableData.toArray();
                        setTableCards(updatedTableData);
                        const ocuTables = updatedTableData.filter((table) => table.statusType === "OCU" || table.statusType === "ONG");
                        setOcupiedTablesData(ocuTables);
                        const resTables = updatedTableData.filter((table) => table.statusType === "RES");
                        setReservedTablesData(resTables);
                        let tempData = [];
                        await db.tableData.toArray().then((fetched) => {
                          tempData.push(...fetched);
                        });
                        setTableList(tempData);
                      } else {
                        setIsCardPaymentFlag(false);
                        setKeyValue("1");
                      }
                    }}
                  >
                    {getMultilingualText("New Order")}
                  </Button>
                )}

                {/* <Button
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                    border: "1px solid #92909880",
                    height: "7.5vh",
                    color: "#2F3856",
                    fontSize: "1em",
                    fontWeight: 500,
                    width: "23vw",
                  }}
                  onClick={() => {
                    setShowOrderCompleteFlag(false);
                    setPaymentVisible(false);

                    if (isSplitBill) {
                      const updatedSplits = [...splitCarts];
                      updatedSplits.splice(currentSplitIndex, 1);
                      if (updatedSplits.length > 0) {
                        const regeneratedSplits = updatedSplits.map((split, index) => {
                          const sOrderID = uuidv4().replace(/-/g, "").toUpperCase();
                          return {
                            ...split,
                            payments: [],
                            isSplit: "Y",
                            sOrderID,
                            referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
                            giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                            couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                          };
                        });
                        setSplitCarts(regeneratedSplits);
                        setCurrentSplitIndex(0);
                        setCart(regeneratedSplits[0]);
                        setSplitBillScreen(true);
                      } else {
                        setIsSplitBill(false);
                        setSplitCarts([]);
                        setCurrentSplitIndex(0);
                        setKeyValue("0");
                      }
                    }
                  }}
                >
                  Other Splits
                </Button> */}

                {/* <Button
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                    height: "7.5vh",
                    color: "#0F0718",
                    fontWeight: 500,
                    fontSize: "1em",
                    width: "23vw",
                  }}
                  onClick={async () => {
                    localStorage.setItem("dineIn", "Y");
                    setKeyValue("0");
                    setShowOrderCompleteFlag(false);
                    setPaymentVisible(false);
                    setShowProducts(false);
                    const cart = JSON.parse(localStorage.getItem("cartObj"));
                    if (saleType === "TA") {
                      localStorage.setItem("dineIn", "N");
                      setKeyValue("2");
                    } else if (saleType === "DI") {
                      setSplitBillScreen(false);
                      setKeyValue("0");
                      const updatedTableData = await db.tableData.toArray();
                      setTableCards(updatedTableData);
                      const ocuTables = updatedTableData.filter((table) => table.statusType === "OCU");
                      setOcupiedTablesData(ocuTables);
                      const resTables = updatedTableData.filter((table) => table.statusType === "RES");
                      setReservedTablesData(resTables);
                      let tempData = [];
                      await db.tableData.toArray().then((fetched) => {
                        tempData.push(...fetched);
                      });
                      setTableList(tempData);
                    } else {
                      setIsCardPaymentFlag(false);
                      setKeyValue("1");
                    }
                  }}
                >
                  {getMultilingualText("New Order")}
                </Button> */}
              </Space>
            </Col>
          </Row>
        </div>
      ) : (
        <div style={{ display: "flex" }}>
          <div
            style={{
              width: cart.items.length > 0 ? "69%" : "100%",
              height: "100vh",
            }}
          >
            {renderPaymentSection()}
          </div>
          {cart.items.length > 0 ? (
            <div
              style={{
                background: "#fff",
                height: "100vh",
                width: "31%",
                position: "relative",
                fontSize: "1vw",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "2vh 1vw 0 1vw",
                }}
              >
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: "1.5em",
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Order Details")}
                </span>
                <span style={{ fontWeight: 500, fontSize: "1em", color: "#929098" }}>{moment(cart.orderTime).format(userPreferences.dateFormat)}</span>
              </div>
              {saleType === "DI" && (
                <p
                  style={{
                    padding: "0 1vw",
                    fontSize: "1em",
                    color: "#0F0718",
                    fontWeight: 500,
                    marginBottom: "5px",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    {selectedTable?.name}
                    <span style={{ fontSize: "1em", fontFamily: "Arial, sans-serif", marginLeft: "1rem" }}>{guestName}</span>
                  </div>
                </p>
              )}
              <button
                style={{
                  marginLeft: "0.9vw",
                  color: "#0F0718",
                  backgroundColor: "#fff",
                  border: "1px solid #92909880",
                  fontSize: "0.85em",
                  borderRadius: "4px",
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0.2vh 0.5vw",
                  cursor: "pointer",
                }}
              >
                <img src={userIcon} style={{ height: 15, width: "1.5vw", marginRight: "0.2vw" }} />
                {cart?.customer?.name}
              </button>

              <hr style={{ color: "#929098", width: "93%" }} />
              <Scrollbars
                autoHide
                // style={{ height: "58vh" }}
                style={{
                  // height: "46vh"
                  height: localStorage.getItem("dineIn") === "N" ? "56vh" : "52vh",
                }}
              >
                <InfiniteScroll
                  dataLength={cart.items.length}
                  hasMore={true}
                  endMessage={
                    <p className="center">
                      <b>Yay! you have seen it all</b>
                    </p>
                  }
                  style={{ overflowX: "hidden" }}
                >
                  {cart.items
                    .filter((item) => item.isCanceled !== "Y")
                    .map((item) => {
                      return (
                        <div style={{ padding: "6px 10px" }}>
                          <div
                            style={{ fontSize: "0.9vw", backgroundColor: selectedProductId === item.lineId ? "#f0f0f0" : "transparent" }}
                            onClick={() => {
                              setSelectedProductId(item.lineId);
                              setSelectedProductInCart(item);
                            }}
                          >
                            <Row>
                              <Col span={3}>
                                <img
                                  src={item.imageurl || defaultImage}
                                  alt={item.productAliasName ? item.productAliasName : item.name}
                                  style={{
                                    // height: "8vh",
                                    height: item.description ? "6.5vh" : "6vh",
                                    maxWidth: "100%",
                                    objectFit: "cover",
                                    borderRadius: "7px",
                                  }}
                                />
                              </Col>
                              <Col
                                span={16}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  paddingLeft: "0.5vw",
                                  marginRight: "30px",
                                }}
                              >
                                <Tooltip title={item.productAliasName ? item.productAliasName : item.name} placement="top">
                                  <Text
                                    style={{
                                      fontSize: "1em",
                                      fontWeight: "500",
                                      color: "#0F0718",
                                      marginRight: "0.3rem",
                                      maxWidth: "18vw",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {item.productAliasName ? item.productAliasName : item.name}
                                  </Text>
                                </Tooltip>
                                <Text
                                  style={{
                                    fontSize: "0.8em",
                                    color: "#929098",
                                    fontWeight: 400,
                                  }}
                                >
                                  {item.description}
                                </Text>
                                <Text>
                                  {" "}
                                  {item?.selectedAddons?.map((subitem) => (
                                    <Row>
                                      <Col span={14}>
                                        <p style={{ fontSize: "0.8em", color: "#929098", marginBottom: 0 }}>+ {subitem.name}</p>
                                      </Col>
                                    </Row>
                                  ))}
                                </Text>
                                <Text
                                  style={{
                                    fontWeight: 600,
                                    fontSize: "1.1em",
                                    color: "#0F0718",
                                  }}
                                >
                                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                  {item.sunitprice.toFixed(item?.isQtyDesimal)}
                                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                                </Text>
                              </Col>
                              <Col
                                span={2}
                                style={{
                                  textAlign: "center",
                                  color: "#0F0718",
                                  fontWeight: 500,
                                  fontSize: "1.1em",
                                }}
                              >
                                X {item.weight}
                              </Col>
                              <span
                                style={{
                                  background: Math.abs(item.discount) > 0 ? "#F8C519" : "",
                                  borderRadius: "3px",
                                  padding: "0.25vw",
                                  display: item.discountName ? "" : "none",
                                  fontSize: "0.7em",
                                  marginTop: "1vh",
                                }}
                              >
                                {Math.abs(item.discount) > 0 ? item.discountName ? <img src={Offers} alt="" width={12} height={12} style={{ marginTop: "-2px" }} /> : "" : ""}{" "}
                                {Math.abs(item.discount) > 0 ? item.discountName || "" : ""}{" "}
                              </span>
                            </Row>
                          </div>
                        </div>
                      );
                    })}
                </InfiniteScroll>
              </Scrollbars>
              <div
                style={{
                  padding: "1vh 0.6vw",
                  position: "absolute",
                  bottom: "1vh",
                  width: "100%",
                }}
              >
                <div
                  onClick={() => showCharges(!charges)}
                  style={{
                    cursor: "pointer",
                    fontWeight: 500,
                    fontSize: "1em",
                    background: "#F3F4F9",
                    padding: "0.5vh 0.5vw",
                    borderRadius: "5px",
                    marginBottom: "1vh",
                  }}
                >
                  View Details {charges ? "▲" : "▼"}
                </div>
                {charges && (
                  <Scrollbars style={{ height: "18vh" }}>
                    <Space
                      direction="vertical"
                      style={{
                        width: "100%",
                        background: "#F3F4F9",
                        padding: "1vh 0.5vw",
                        borderRadius: "10px",
                        rowGap: "4px",
                      }}
                    >
                      {/* ───────────── Sub-total ───────────── */}
                      <Space style={{ width: "100%", justifyContent: "space-between" }}>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Subtotal")}</Text>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                          {(cart.total - cart.tax).toFixed(pricePrecision)}
                          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                        </Text>
                      </Space>

                      {/* ───────────── Discount ───────────── */}
                      <Space style={{ width: "100%", justifyContent: "space-between" }}>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Discount Sales")}</Text>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                          {parseFloat(cart.discount || 0).toFixed(pricePrecision)}
                          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                        </Text>
                      </Space>

                      {/* ───────────── Sales tax ───────────── */}
                      <Space style={{ width: "100%", justifyContent: "space-between" }}>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Total Sales Tax")}</Text>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                          {parseFloat(cart.tax || 0).toFixed(pricePrecision)}
                          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                        </Text>
                      </Space>

                      {/* ───────────── Service Charge ───────────── */}
                      {parseFloat(cart.serviceCharge || 0) > 0 && (
                        <Space style={{ width: "100%", justifyContent: "space-between" }}>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Service Charge")}</Text>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {parseFloat(cart.serviceCharge).toFixed(pricePrecision)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                          </Text>
                        </Space>
                      )}

                      {/* ───────────── Tip ───────────── */}
                      {parseFloat(cart.tip || 0) > 0 && (
                        <Space style={{ width: "100%", justifyContent: "space-between" }}>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Tip")}</Text>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {parseFloat(cart.tip).toFixed(pricePrecision)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                          </Text>
                        </Space>
                      )}

                      {/* ───────────── Delivery Charge ───────────── */}
                      {parseFloat(cart.deiveryCharge || cart.deliveryCharge || 0) > 0 && (
                        <Space style={{ width: "100%", justifyContent: "space-between" }}>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Delivery Charge")}</Text>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {parseFloat(cart.deiveryCharge || cart.deliveryCharge).toFixed(pricePrecision)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                          </Text>
                        </Space>
                      )}

                      {/* ───────────── Packing Charge ───────────── */}
                      {parseFloat(cart.packingCharge || 0) > 0 && (
                        <Space style={{ width: "100%", justifyContent: "space-between" }}>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Packing Charge")}</Text>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {parseFloat(cart.packingCharge).toFixed(pricePrecision)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                          </Text>
                        </Space>
                      )}

                      {/* ───────────── Existing Payment List ───────────── */}
                      <Space direction="vertical" style={{ width: "100%", padding: 0 }} size={3}>
                        {cart?.payments?.map((item, index) => (
                          <div key={index} style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                            <Text style={{ fontSize: "1em", fontWeight: 500, color: "#008000", fontFamily: "Inter" }}>
                              {item.name.toLowerCase() === "card" ? `${item.name}${item.authorization ? ` - ${item.authorization}` : ""}` : item.name}{" "}
                              {getMultilingualText("Payment")}
                            </Text>
                            <Text style={{ fontSize: "1em", fontWeight: 500, color: "#008000", fontFamily: "Inter" }}>
                              {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                              &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}&nbsp;&nbsp;
                              <img src={DeleteImg} onClick={() => handleDeletePayment(item)} style={{ height: "15px", width: "15px", cursor: "pointer" }} />
                            </Text>
                          </div>
                        ))}
                        {cart?.paymentData?.map((item, index) => (
                          <div key={index} style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                            <Text style={{ fontSize: "1em", fontWeight: 500, color: "#008000", fontFamily: "Inter" }}>
                              {item.name.toLowerCase() === "card" ? `${item.name}${item.authorization ? ` - ${item.authorization}` : ""}` : item.name}{" "}
                              {getMultilingualText("Payment")}
                            </Text>
                            <Text style={{ fontSize: "1em", fontWeight: 500, color: "#008000", fontFamily: "Inter" }}>
                              {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                              &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}&nbsp;&nbsp;
                            </Text>
                          </div>
                        ))}
                      </Space>
                    </Space>
                  </Scrollbars>
                )}
                <Space style={{ width: "100%", justifyContent: "space-between", marginTop: "2px" }}>
                  <Text style={{ fontSize: "1.1em", color: "#0F0718", fontWeight: 600 }}>{getMultilingualText("Total Amount")}</Text>
                  <Text style={{ fontSize: "1.1em", color: "#0F0718", fontWeight: 600 }}>
                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                    {(
                      Math.floor(
                        (parseFloat(cart.total) +
                          parseFloat(cart.serviceCharge || 0) +
                          parseFloat(cart.tip || 0) +
                          parseFloat(cart.deiveryCharge || cart.deliveryCharge || 0) +
                          parseFloat(cart.packingCharge || 0)) *
                          100
                      ) / 100
                    ).toFixed(pricePrecision)}
                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                  </Text>
                </Space>
                <div>
                  <Space direction="horizontal" style={{ paddingTop: "1.5vh", fontSize: "1vw" }}>
                    {tillData?.tillAccess?.manualDiscount === "Y" && (
                      <Button
                        style={{
                          width: "27.1vw",
                          border: "1px solid rgba(146, 144, 152, 0.5)",
                          borderRadius: "10px",
                          color: "#2F3856",
                          height: "5.5vh",
                          fontSize: "1em",
                          fontWeight: "500",
                          marginLeft: "0.3em",
                        }}
                        onClick={manualDiscountRestaurant}
                      >
                        <img src={DiscountIcon} style={{ paddingRight: "0.3rem", height: "2.5vh" }} />
                        <span>Add Discount</span>
                      </Button>
                    )}
                    {/* <Button
                      style={{
                        width: "13.5vw",
                        borderRadius: "10px",
                        color: "#2F3856",
                        height: "5.5vh",
                        fontSize: "1em",
                        fontWeight: "500",
                      }}
                    >
                      <img src={printBill} style={{ paddingRight: "0.3rem", height: "2.5vh" }} />
                      <span>Print Bill</span>
                    </Button> */}
                  </Space>
                </div>
                <div>
                  <Space direction="horizontal" style={{ paddingTop: "2vh" }}>
                    <Button
                      disabled={isProcessing}
                      onClick={async () => {
                        if (isProcessing) return;

                        try {
                          setIsProcessing(true);
                          if (!selectedPayment && paymentVisible) {
                            message.warning(`${messages.warnings.payment.select_payment_method}`);
                            return;
                          }
                          const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                          const denominationsValue = filtredCurrencies[0]?.value || 1;
                          const scale = 100; // For 2 decimal places
                          const scaledDividend = Math.round(amount * scale); // 1040
                          const scaledDivisor = Math.round(denominationsValue * scale); // 20

                          const scaledRemainder = scaledDividend % scaledDivisor;
                          const remainder = scaledRemainder / scale;
                          const isReturnFlow = selectedPaymentMethod?.isReturns === "Y";
                          const isGiftCardOrLoyalty =
                            selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
                            selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
                            selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
                          if (isGiftCardOrLoyalty && paymentVisible) {
                            if (parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                              console.log("Checking payment method and remainder...");
                              if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && remainder !== 0) {
                                message.warning(`${messages.warnings.payment.payment_multiple_check} ${denominationsValue}`);
                              } else {
                                setNumb(0);
                                if (!isReturnFlow && cart.paid + parseFloat(amount) > cart.total.toFixed(2) && selectedPaymentMethod?.name?.toLowerCase() !== "cash") {
                                  message.warn(`${messages.errors.cart.overpayment_not_allowed}`);
                                  return;
                                }
                                requestPayment(selectedPaymentMethod, amount);
                                if (localStorage.getItem("dineIn") === "Y") {
                                  console.log("Marking table bill as requested...");
                                  await markTableBillRequested();
                                }
                                await handleOrderCompletion(amount);
                                setSelectedPayment(false);
                                if (localStorage.getItem("dineIn") === "Y") {
                                  const updatedTableData = await db.tableData.toArray();
                                  setTableCards(updatedTableData);
                                  setMainTableData(updatedTableData);
                                  const updatedOccupiedData = updatedTableData.filter((table) => table?.statusType === "OCU" || table.statusType === "ONG");
                                  setOcupiedTablesData(updatedOccupiedData);
                                  const updatedReservedData = updatedTableData.filter((table) => table.statusType === "RES");
                                  setReservedTablesData(updatedReservedData);
                                }
                                if (isSplitBill) {
                                  const updatedSplits = splitCarts.filter((split) => split.splitNo !== removeSplit.splitNo);
                                  if (updatedSplits.length > 0) {
                                    const regeneratedSplits = updatedSplits.map((split, index) => {
                                      const sOrderID = uuidv4().replace(/-/g, "").toUpperCase();
                                      return {
                                        ...split,
                                        payments: [],
                                        isSplit: "Y",
                                        sOrderID,
                                        referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
                                        giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                                        couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                                      };
                                    });
                                    setSplitCarts(regeneratedSplits);
                                    setCurrentSplitIndex(0);
                                    setCart(regeneratedSplits[0]);
                                    setSplitBillScreen(true);
                                  } else {
                                    setIsSplitBill(false);
                                    setSplitCarts([]);
                                    setCurrentSplitIndex(0);
                                    setKeyValue("0");
                                  }

                                  localStorage.setItem("tableName", JSON.stringify(recordState));
                                }
                              }
                            } else {
                              console.log("here");
                              setShowOrderCompleteFlag(true);
                              processOrder();
                            }
                          } else if (paymentVisible === false) {
                            setPaymentVisible(true);
                          }
                        } catch (error) {
                          console.error("Payment Error:", error);
                        } finally {
                          setIsProcessing(false);
                        }
                      }}
                      style={{
                        width: "27.8vw",
                        borderRadius: "10px",
                        backgroundColor: paymentVisible ? (selectedPayment ? "#2F3856" : "#92909880") : "#2F3856",
                        color: "#fff",
                        height: "6vh",
                        fontSize: "1em",
                        fontWeight: 500,
                      }}
                    >
                      {paymentVisible ? `${getMultilingualText("Add Payment")}` : `${getMultilingualText("Pay Bill")}`}
                    </Button>
                  </Space>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </>
  );
};

export default OrderListComponent;
